<template>
    <span
        ><slot :load="load" :response="response" :loading="loading"></slot
    ></span>
</template>
<script>
import { StorageService } from '../services/storage';
import { useApp } from 'src/composables/app';
const basePath = process.env.VUE_APP_PUBLIC_URL  || "/";
const localStore = StorageService;
export default {
    props: {
        loadOnMount: {
            type: Boolean,
            default: true,
        },
        apiPath: "",
        value: "",
        firstRecord: false, // should return single object from the response array
        queryParams: {
            type: Object,
            default: () => ({}),
        },
    },
    data: function () {
        return {
            response: [],
            loading: false,
        };
    },
    computed: {
        apiUrl: function () {
            let qs = this.$utils.serializeQuery(this.queryParams);
            let url = this.apiPath;
            if (qs) {
                url = url + "?" + qs;
            }
            return url;
        },
    },
    methods: {
        load: function () {
            if (this.apiUrl) {
                this.loading = true;
                this.$api.get(this.apiUrl).then(
                    (response) => {
                        this.loading = false;
                        let result = response.data;
                        if (this.firstRecord && result.length) {
                            this.response = result[0];
                        } else {
                            this.response = result;
                        }
                        this.$emit("loaded", this.response);
                    },
                    (error) => {
                        this.loading = false;
                        if (this.firstRecord) {
                            this.response = {};
                        } else {
                            this.response = [];
                        }

                        // Manejo centralizado de errores usando el composable `useApp`
                        const app = useApp();
                        try {
                            app.showPageRequestError(error);
                        } catch (ex) {
                            // Fallback: si algo falla, loguear y asegurarnos de limpiar login si es 401
                            console.error('Error manejando la respuesta de la API:', ex);
                            const xhrRequest = error?.request;
                            if (xhrRequest?.status === 401) {
                                localStore.removeLoginData();
                                location.href = basePath;
                            }
                        }
                    }
                );
            }
        },
    },
    watch: {
        apiUrl: function () {
            this.load();
        },
    },
    mounted: function () {
        if (this.loadOnMount) {
            this.load();
        }
    },
};
</script>
